import { useEffect, useState } from "react";
import { MessageCircle, X } from "lucide-react";
import { buildWhatsAppLink, PHONE_NUMBER_DISPLAY } from "../lib/contact";

export const FloatingWhatsApp = () => {
    const [show, setShow] = useState(false);
    const [tipOpen, setTipOpen] = useState(false);

    useEffect(() => {
        const onScroll = () => setShow(window.scrollY > 240);
        onScroll();
        window.addEventListener("scroll", onScroll, { passive: true });
        // Show tip 4s after first reveal
        const t = setTimeout(() => setTipOpen(true), 3500);
        return () => {
            window.removeEventListener("scroll", onScroll);
            clearTimeout(t);
        };
    }, []);

    return (
        <div
            data-testid="floating-whatsapp-wrapper"
            className={`fixed bottom-5 right-5 sm:bottom-6 sm:right-6 z-50 flex flex-col items-end gap-3 transition-all duration-300 ${
                show ? "opacity-100 translate-y-0" : "opacity-0 translate-y-3 pointer-events-none"
            }`}
        >
            {/* Tooltip card */}
            {tipOpen && (
                <div
                    data-testid="floating-whatsapp-tip"
                    className="relative bg-white text-black px-4 py-3 pr-10 max-w-[260px] shadow-2xl border border-black/10 animate-[fadeUp_0.4s_ease]"
                    role="dialog"
                    aria-label="WhatsApp quick tip"
                >
                    <button
                        type="button"
                        onClick={() => setTipOpen(false)}
                        aria-label="Dismiss"
                        data-testid="floating-whatsapp-tip-close"
                        className="absolute top-1.5 right-1.5 w-6 h-6 flex items-center justify-center text-neutral-500 hover:text-black"
                    >
                        <X size={14} />
                    </button>
                    <div className="font-display text-base uppercase tracking-wide leading-tight">
                        Need a crane?
                    </div>
                    <div className="font-body text-xs text-neutral-700 mt-1">
                        Chat with us on WhatsApp — replies in ~10 min.
                    </div>
                    <div className="font-body text-[10px] text-neutral-500 mt-1">
                        {PHONE_NUMBER_DISPLAY}
                    </div>
                    {/* Arrow */}
                    <span className="absolute -bottom-2 right-7 w-4 h-4 bg-white border-r border-b border-black/10 rotate-45" />
                </div>
            )}

            {/* Button */}
            <a
                href={buildWhatsAppLink()}
                target="_blank"
                rel="noopener noreferrer"
                aria-label="Chat with Surya Crane on WhatsApp"
                data-testid="floating-whatsapp-button"
                className="relative inline-flex items-center justify-center w-14 h-14 sm:w-16 sm:h-16 bg-[#25D366] hover:bg-[#1EBE5B] text-white shadow-2xl shadow-emerald-900/30 transition-all duration-300 hover:scale-110 focus-ring"
            >
                <span className="absolute inset-0 bg-[#25D366] pulse-ring" aria-hidden />
                <MessageCircle size={28} strokeWidth={2.4} className="relative" />
            </a>
        </div>
    );
};
